import { Power } from 'lucide-react';
import { toast } from 'sonner';

import { BusinessLogo } from '@/components/custom/business-logo';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { useUserLogoutMutation } from '@/features/auth/api/useUsersLogoutMutation';
import { useStore } from '@/stores';

const QuickLogout = () => {
  const userProfile = useStore((state) => state.profile);
  const accessToken = useStore.getState().accessToken;
  // const { setPopupAnnountcement } = useStore();

  const { mutate } = useUserLogoutMutation({
    onSuccess: () => {
      // setPopupAnnountcement({ shownPopupAnnountcement: false });
      localStorage.removeItem('dashboard-merchant-storage');
      window.location.replace('/auth/login');
    },
    onError: (err) => {
      toast.error('Logout is failed', { description: err.message });
    },
  });

  const signOut = async () => {
    if (!accessToken) return;
    mutate({ access_token: accessToken });
  };

  return (
    <div className="sticky bottom-0 p-4">
      <div className="flex flex-row items-center justify-between rounded-lg bg-blue-50 p-4">
        <div className="flex flex-row items-center gap-2">
          <div
            data-testid="sidebar-avatar-business-logo"
            className="h-10 w-10 items-center justify-center overflow-hidden rounded-full border border-gray-200 bg-white"
          >
            {userProfile ? (
              <BusinessLogo model={userProfile.business.logo_path} />
            ) : (
              <Avatar className="h-full w-full">
                <AvatarImage src={'/images/profile/user-1.jpg'} />
                <AvatarFallback>doitpay</AvatarFallback>
              </Avatar>
            )}
          </div>
          <div>
            <div className="font-bold text-black">{userProfile?.business.name || '-'}</div>
            <div className="text-gray-500">{userProfile?.name || '-'}</div>
          </div>
        </div>
        <div className="p-2" onClick={signOut}>
          <Power className="text-brand-blue h-5 w-5" />
        </div>
      </div>
    </div>
  );
};

export default QuickLogout;
